import * as z from "zod/v4";

export const updateCreditsYardIntegration = {
  name: "updateCreditsYardIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    shopApiKey: z.string().min(1, "Shop API Key is required").optional(),
  }),
  output: z.object({}),
};
